import { render, staticRenderFns } from "./Unsell.vue?vue&type=template&id=22f4b623"
import script from "./Unsell.vue?vue&type=script&lang=js"
export * from "./Unsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports